// extracted by mini-css-extract-plugin
export default {"alert-success":"rgb(30, 133, 59)","alert-danger":"rgb(218, 30, 40)","gray-20":"rgb(221, 224, 230)","gray-60":"rgb(105, 111, 119)","activityInfoGrid":"styles_activityInfoGrid__YdiEF"};